module.exports = __webpack_public_path__ + "img/数据图形-pc.c3729ecf.png";